import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import { CancellationDatePicker } from './CancellationDatePicker.js';

const CancellationDatePickerContainer = ({ name  })=>{
    // useIntl dateFormat is typed as string but maps to DatePickerFormat
    // DatePicker component internally uses ReactDatePickerProps.dateFormat?: string | string[] | undefined
    const { dateTime , dateFormat , getLabel  } = useIntl();
    const labels = React.useMemo(()=>({
            label: getLabel('cancelSubscription.field.cancellationDate'),
            placeholder: dateTime.formatMidsizeDate(new Date()),
            errorMessage: getLabel('cancelSubscription.field.cancellationDate.errorMessage')
        })
    , [
        getLabel,
        dateTime
    ]);
    const minDate = new Date();
    return /*#__PURE__*/ React.createElement(CancellationDatePicker, {
        name: name,
        label: labels.label,
        placeholder: labels.placeholder,
        errorMessage: labels.errorMessage,
        minDate: minDate,
        dateFormat: dateFormat.midsize
    });
};

export { CancellationDatePickerContainer };
//# sourceMappingURL=CancellationDatePickerContainer.js.map
